import ModelCountReferency from "./Chart/ModelCountReferency";
import BestAccuracy from "./Chart/BestAccuracy";
import TrainAccuracy from "./Chart/TrainAccuracy.vue";
import DashboardService from "../../services/Dashboard.service";
import MaintenanceService from "../../services/Maintenance.service";
import { alertResponseError } from "../../helpers/general";

export default {
    name: "App",
    components: {
        ModelCountReferency,
        BestAccuracy,
        TrainAccuracy
    },
    data() {
        return {
            modelCount: 0,
            sumReference: 0,
            sumTrainHistory: 0,
            modelTrainHistoryAccuracy: '',
            isShowGraphModelCountReferency: true,
            isShowGraphBestAccuracy: true,
            isShowGraphTrainAccuracy: true,
            maintenances: []
        }
    },
    methods: {
        countModel() {
            return DashboardService.countModel().then((response) => {
                if (response.data.success) {
                    this.modelCount = response.data.data.sum_model;
                }
            }).catch((error) => {
                alertResponseError(error);
            });
        },
        sumInferences() {
            return DashboardService.sumInferences().then((response) => {
                if (response.data.success) {
                    this.sumReference = response.data.data.sum_references;
                }
            }).catch((error) => {
                alertResponseError(error);
            })
        },
        countTrainHistory() {
            return DashboardService.countTrainHistory().then((response) => {
                if (response.data.success) {
                    this.sumTrainHistory = response.data.data.sum_train_history;
                }
            }).catch((error) => {
                alertResponseError(error);
            })
        },
        getMaintenaceInfo() {
            return MaintenanceService.getMaintenaceInfo().then((response) => {
                if (response.data.success) {
                    this.maintenances = response.data.data;
                }
            }).catch((error) => {
                alertResponseError(error);
            })
        },
        showMaintenaceDetail(detail) {
            return detail.replace(/(?:\r\n|\r|\n)/g, '<br>');
        }
            
    },
    created() {
        document.title = this.$t(`${this.$route.meta.title}.title_page`);
        this.countModel();
        this.sumInferences();
        this.countTrainHistory();
        this.getMaintenaceInfo();
    }
};
